import UserService from "@/services/UserService.js"

export const namespaced = true
export const state = {
  n_users: [],
  n_user: {},
  n_user_edit: {},
  n_current_user: {},
  n_current_user_has_access: false
}

export const mutations = {
  SET_N_USERS(state, n_users) {
    state.n_users = n_users
  },
  SET_USER_EDIT(state, n_user_edit) {
    state.n_user_edit = n_user_edit
  },
  SET_CURRENT_USER(state, n_user) {
    state.n_current_user = n_user
    state.n_current_user_has_access = true
  },
  LOGOUT_CURRENT_USER(state) {
    state.n_current_user = {}
    state.n_current_user_has_access = false
  },
  ADD_USER(state, user) {
    state.n_users.push(user)
  },
  DELETE_USER(state, user) {
    state.n_users = state.n_users.filter(
      del => del.UserProfileID !== user.UserProfileID
    )
  }
}

export const getters = {
  getUserById: state => id => {
    //console.log(state)
    return state.n_users.find(n_user => n_user.UserProfileID === id)
  },
  UserCount: state => {
    return state.n_users.length
  }
}

export const actions = {
  fetchUsers({ commit }) {
    return UserService.get_NUsers()
      .then(response => {
        //Note: use rootstate to pass in global state to access
        //data from other modules (this comes from store.js)
        //console.log('from another module: ' + rootState.user.user.name)
        //console.log('total events: ' + response.headers['x-total-count'])
        commit("SET_N_USERS", response.data)
        //commit("SET_EVENTCOUNT", response.headers["x-total-count"])
      })
      .catch(error => {
        console.log(error.message)
        // const notification = {
        //   type: "error",
        //   message: "there was an error fetching events: " + error.message
        // }
        // dispatch("notification/add", notification, { root: true })
      })
  },
  loadUserEdit({ commit, getters, dispatch }, value) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    console.log(value)
    var user = getters.getUserById(value)
    if (user) {
      console.log("FROM GETTER")
      console.log(user)
      commit("SET_USER_EDIT", user)
    } else {
      console.log("calling API")
      /* return EventService.getEvent(value)
        .then(response => {
          commit("SET_EVENT", response.data)
        })
        .catch(error => {
          const notification = {
            type: "error",
            message: "there was an error fetching event: " + error.message
          }
          dispatch("notification/add", notification, { root: true })
        })
      //}*/
    }
  },
  createUser({ commit, dispatch }, user) {
    commit("ADD_USER", user)
  },
  Save({ commit, getters, dispatch }, { user, fields }) {
    //This is good, use getters first then call api
    // changing it to test progress bars
    if (user) {
      console.log("FROM SAVE")
      console.log(fields[0].FieldName)
      console.log(user.FirstName)
      //commit("SET_USER_EDIT", user)
      UserService.Save(user, fields)
      //UserService.SaveTest(user.FirstName)
    } else {
      console.log("calling API")
      /* return EventService.getEvent(value)
        .then(response => {
          commit("SET_EVENT", response.data)
        })
        .catch(error => {
          const notification = {
            type: "error",
            message: "there was an error fetching event: " + error.message
          }
          dispatch("notification/add", notification, { root: true })
        })
      //}*/
    }
  },
  New({ commit }) {
    commit("SET_USER_EDIT", {
      UserProfileID: -1
    })
  },
  Delete({ commit }, user) {
    return UserService.Delete(user)
      .then(response => {
        commit("DELETE_USER", user)
      })
      .catch(error => {
        console.log(error.message)
      })
  },
  authenticate({ commit }, { username, password }) {
    return UserService.Authenticate(username, password)
      .then(response => {
        var _user = response.data["AuthenticateResult"]
        //alert(_user.FirstName)
        //alert(response.data["AuthenticateResult"].UserProfileID)
        commit("SET_CURRENT_USER", _user)
      })
      .catch(error => {
        console.log(error.message)
      })
  },
  logout({ commit }) {
    commit("LOGOUT_CURRENT_USER")
    return true
  }

  //   return UserService.postUser(user)
  //     .then(() => {
  //       commit("ADD_USER", user)
  //       const notification = {
  //         type: "success",
  //         message: "Event Successfully Added: " + event.id
  //       }
  //       dispatch("notification/add", notification, { root: true })
  //     })
  //     .catch(error => {
  //       console.log("error")
  //       const notification = {
  //         type: "error",
  //         message:
  //           "Problem with user: " + user.UserProfileID + ": " + error.message
  //       }
  //       dispatch("notification/add", notification, { root: true })
  //       throw error
  //     })
  // }
}
